import { getCurrencySymbol } from "../js/itemPropsHelper";

const OptionThumbnail = ({ imgSrc, alt }) => {
  const classNames = `size-6 sm:size-8`

  return (
    <div
      class={`${classNames} inline-svg-container`}
      innerHTML={imgSrc}
    >
    </div>
  )
}

export const OptionCard = (props) => {

  const { id, label, displayName, thumbnailSrc,  tooltip, styleImageSrc, chargeVariant } = props.option;
  const isSelected = () => props.option.id == props.selectedValue
  const className = props.className;  

  return (
    <div
      class="flex justify-center w-full "
      classList={{
        'sm:w-max': !props.inlineImageOnDesktop,
        "boxy-shadow": isSelected(),
        "order-2": props.isDefault == false
      }}
    >      
      <input
        id={id}
        class={`hidden design-option-input-element`}
        value={label}
        type="radio"
      />
      <label
        for={id}
        class={`bg-canvas  group relative flex w-full cursor-pointer items-stretch ${ props.hideIcon ?  'justify-center' : 'justify-between' } hover:bg-canvas-light border border-solid border-frame p-1 sm:p-1 option-active min-w-max`}
        classList={{
          "bg-canvas-light": isSelected()
        }}
        onClick={() => props.handleSelection(props.option.id)}
      >
        <div className={`flex ${ styleImageSrc != undefined && styleImageSrc.trim().length > 0 ? "flex-col" : "flex-row items-center"} ${ props.inlineImageOnDesktop ? '' : 'sm:flex-row'} justify-between gap-1`}>
          {
            thumbnailSrc != undefined && thumbnailSrc.trim().length > 0 && props.hideIcon != true
              ? <OptionThumbnail
                imgSrc={thumbnailSrc}
                label={`${label} image`}
              />
              : null
          }
          <div 
            class="flex"
            classList={{
              "flex-col": styleImageSrc != undefined && styleImageSrc.trim().length > 0,
              "items-center gap-0.5": !(styleImageSrc != undefined && styleImageSrc.trim().length > 0)
            }}>
            <Show when={chargeVariant}>
              <span 
                class="bg-frame-dark text-frame-light px-0.5 rounded-md text-xs w-fit"
              >{getCurrencySymbol()}+</span>
            </Show>
            <span 
              class={`${ styleImageSrc != undefined && styleImageSrc.trim().length > 0 ? "text-lg  max-w-min sm:w-min text-left" : "text-sm text-center "} text-ink  sm:text-sm font-medium liga-off inline-block flex-grow-0 lg:w-auto ${className != undefined ? className : ""}`}
              classList={{
                "-order-1": !(styleImageSrc != undefined && styleImageSrc.trim().length > 0)
              }}
            >{displayName || label}</span>
            {
              tooltip != undefined && tooltip.trim().length > 0
                ? <div class={`tooltip rounded-full h-2 w-2 text-center font-regular text-xs mt-1 cursor-default bg-primary-100`} title={tooltip}>i</div>
                : null
            }
          </div>
        </div>

        {
          styleImageSrc != undefined && styleImageSrc.trim().length > 0
            ? 
              <img class="size-[40vw] z-20   sm:border  delay-150  transition-opacity duration-500  sm:border-frame   aspect-square object-cover lazyload" 
                  classList={{ 'sm:size-20 sm:p-1 sm:mb-1 bg-canvas-light sm:absolute sm:opacity-0 sm:group-hover:opacity-100 sm:invisible group-hover:visible sm:bottom-full sm:left-0' : !props.inlineImageOnDesktop,
                  'sm:size-30' : props.inlineImageOnDesktop
                }} 
                  src={ `${styleImageSrc}&width=16` } 
                   width="auto"
                   height="auto"
                   loading="lazy"
                   data-sizes="auto"
                   data-srcset={[160, 188, 212, 256, 300, 340, 400]
                    .map((width) => `${styleImageSrc}&width=${width} ${width}w`)
                    .join(", ")}
                   alt={`Image that shows ${label} customization` } />
            : null
        }
      </label>
      
    </div>
  );
}